module.exports = __webpack_public_path__ + "img/043.b46fbf91.png";